
import { clusterService } from '../../services/cluster.service';
import { staffService } from '../../services/staff.service';
import { trackService } from "../../services/track.services";
import { mapMarkerService } from '../../services/map.marker.service';
import { STORE_CONSTANTS } from '../../common/store.constants';
import { clientEventService } from '../../services/client.event.service';

const MUTATION_NAMES = STORE_CONSTANTS.TRACKS.MUTATIONS.WITHOUT_NAMESPACE;

const tracks = {
    namespaced: true,
    actions: {
        getTasks(context, criteria) {
            return new Promise((resolve, reject) => {
                let features = [];

                clusterService.getEagleDay(criteria).then(function (response) {
                    let features = [];
                    if (response && response.data) {
                        features = response.data.features;

                        // find alt addresses
                        let alt_address = mapMarkerService.getAlternateAddresses(features);
                        if (alt_address.length > 0) {
                            for (var i = 0; i < alt_address.length; i++) {
                                features.push(alt_address[i]);
                            }
                        }

                        staffService.getStaffHome(criteria).then(function (response) {
                            if (response && response.data) {
                                features = features.concat(response.data.features);
                            }

                            context.commit(STORE_CONSTANTS.TRACKS.MUTATIONS.WITHOUT_NAMESPACE.SET_TASKS_FEATURES, features);
                            context.dispatch(STORE_CONSTANTS.DAILY_TASKS.ACTIONS.WITH_NAMESPACE.SET_STAFF_DAILY_TASKS, { features: features, criteria: criteria }, {root:true});
                            resolve({ features });
                        })
                        .catch((err) => {
                            reject(err);
                        });
                    } else {
                        context.commit('dailyTasks/clearStaffDailyInfo', {}, { root:true });
                        context.commit('validation/clearMapData', {}, { root:true });
                    }
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        clearTaskTracks(context) {
            context.commit(MUTATION_NAMES.CLEAR_TRACKS_FOR_TASK);
        },
        getTracksForTask(context, criteria) {
            return new Promise((resolve, reject) => {
                let taskTracks = context.getters.getTracksForTask(criteria.taskUUID);
                if(taskTracks) {
                    resolve({ tracks: taskTracks});
                }

                // if we haven't already looked up the tracks
                taskTracks = [];
                trackService.getTracksByTaskId(criteria).then(function (response) {
                    if (response && response.data) {
                        taskTracks = response.data.features;
                    }

                    context.commit(MUTATION_NAMES.SET_TASK_TRACKS, { tracks: taskTracks, id: criteria.taskUUID });
                    resolve({ tracks: taskTracks });
                })
                .catch(function (err) {
                    reject(err);
                });
            });
        },
        getAllClustersForDay(context, criteria) {
            return new Promise((resolve, reject) => {
                let clusters = context.getters.getTracksForTask(criteria.taskUUID);
                if(clusters) {
                    resolve({ clusters: clusters});
                }

                // if we haven't already looked up the clusters
                clusters = [];

                clusterService.getClustersByTaskId(criteria).then(function (response) {
                    if (response && response.data) {
                        clusters = response.data;
                    }

                    context.commit(MUTATION_NAMES.SET_CLUSTER, clusters);
                    resolve({ clusters: clusters });
                })
                .catch(function (err) {
                    reject(err);
                })
            });
        },
        getGpsPointById(context, criteria) {
            return new Promise((resolve, reject) => {

            const staffId = context.rootGetters['staff/getStaffId'];
            const study = criteria.study || context.rootState.study.selectedStudyId;

            let address = null;

            staffService.getStaffHome({
                study,
                staffId
            })
            .then(response => {
                if (response?.data?.features?.length) {
                    const p = response.data.features[0].properties;
                    address = `${p.StreetAddress} ${p.PlaceName}, ${p.AdminAreaCode} ${p.PostCode}`;
                }
            })
            .catch(err => {
                console.warn("Could not load staff home address", err);
            })
            .then(() => {
                return trackService.getTrack(study, criteria.id);
            })
            .then(response => {
                let gpsPoint = response?.data?.features?.[0] || null;

                if (gpsPoint) {
                    gpsPoint.properties.staffAddress = address;

                    context.commit(MUTATION_NAMES.SET_GPS_POINT, {
                        point: gpsPoint,
                        id: criteria.id
                    });
                }

            resolve({ point: gpsPoint });
            })
                .catch(err => reject(err));
            });
        },
        getClusterById(context, criteria) {
            return new Promise((resolve, reject) => {
                let cluster = context.getters.getClusterById(criteria.clusterId);
                if(cluster) {
                    resolve({ cluster: cluster });
                }

                clusterService.getClusterById(criteria).then(function (response) {
                    if (response && response.data) {
                        // cluster = response.data;
                        cluster = (response.data.features && response.data.features.length > 0 ) ? response.data.features[0] : null;
                    }

                    if(cluster) {
                        context.commit(MUTATION_NAMES.SET_CLUSTER, { id: criteria.clusterId, cluster: cluster });
                    }

                    resolve({ cluster: cluster });
                  })
                  .catch(function (err) {
                    reject(err);
                  });
            });
        },

        // TODO - DD - this will handle the problem for now, but we should keep track of what studies
        // 'track' which kind of data: Laptop, Phone, or both...

        // Makes requests to get all tracks for the for the day (laptop & mobile)
        // and combines the results of the calls and set them. This is called
        // from the day tracks button on th emap.
        getAllTracksforDay(context, criteria) {
            return new Promise((resolveOuter, rejectOuter) => {

                // Handle request to fetch client event track info for the day here
                let clientEventCriteria = Object.assign({}, criteria);
                let clientEventPromise = new Promise((resolveEvents, rejectEvents) => {
                    let clientEvents;
                    clientEventService.getClientEvents(clientEventCriteria).then(function (response) {
                        if (response && response.data) {
                            clientEvents = response.data;
                        }
                        resolveEvents({ clientEvents });
                    })
                    .catch(function (err) {
                        rejectEvents(err);
                    });
                });

                // Handle request to fetch LAPTOP track info for the day here
                let laptopCriteria = Object.assign({}, criteria);
                laptopCriteria.source = "LAPTOP";
                let laptopTracksPromise = new Promise((resolveLaptop, rejectLaptop) => {
                    let laptopTracks;
                    trackService.getAllTracksForDay(laptopCriteria).then(function (response) {
                        if (response && response.data) {
                            laptopTracks = response.data.features;
                        }
                        resolveLaptop({ laptopTracks });
                    })
                    .catch(function (err) {
                        rejectLaptop(err);
                    });
                });

                // Handle request to fetch PHONE track info for the day here
                let mobileCriteria = Object.assign({}, criteria);
                mobileCriteria.source = "PHONE";
                let mobileTracksPromise = new Promise((resolvePhone, rejectPhone) => {
                    let mobileTracks;
                    trackService.getAllTracksForDay(mobileCriteria).then(function (response) {
                        if (response && response.data) {
                            mobileTracks = response.data.features;
                        }
                        resolvePhone({ mobileTracks });
                    })
                    .catch(function (err) {
                        rejectPhone(err);
                    });
                });                

                // Resolve requests to the API here
                Promise.all([clientEventPromise, laptopTracksPromise, mobileTracksPromise]).then((values) => {
                    let dayTracks = [];
                    // Make sure they aren't null
                    let clientEvents = (!values[0].clientEvents) ? [] : values[0].clientEvents,
                        laptopTracks = (!values[1].laptopTracks) ? [] : values[1].laptopTracks,
                        phoneTracks = (!values[2].mobileTracks) ? [] : values[2].mobileTracks;
                    
                    // Set the client events in the store call: setClientEvents
                    context.commit(MUTATION_NAMES.SET_CLIENT_EVENTS, clientEvents);

                    // Combine the laptop and phone GPS/track into a single array
                    dayTracks.push(...laptopTracks, ...phoneTracks);
                    // Set the day tracks in the store call: setDayTracks
                    context.commit(MUTATION_NAMES.SET_DAY_TRACKS, dayTracks);                    
                    // Return
                    resolveOuter({ tracks: dayTracks, events: clientEvents });
                })
                .catch((err) => {
                    rejectOuter(err);
                });
            });
        },

        // Makes requests to get all track info for the day (laptop & mobile)
        // and combines the results of the calls and set them, this is called 
        // from the tracks table
        getTracksAndClustersforDay(context, criteria) {
            return new Promise((resolveOuter, rejectOuter) => {

                // Handle request to fetch client event track info for the day here
                let clientEventCriteria = Object.assign({}, criteria);
                let clientEventPromise = new Promise((resolveEvents, rejectEvents) => {
                    let clientEvents;
                    clientEventService.getClientEvents(clientEventCriteria).then(function (response) {
                        if (response && response.data) {
                            clientEvents = response.data;
                        }
                        resolveEvents({ clientEvents });
                    })
                    .catch(function (err) {
                        rejectEvents(err);
                    });
                });

                // Handle request to fetch LAPTOP track info for the day here
                let laptopCriteria = Object.assign({}, criteria);
                laptopCriteria.source = "LAPTOP";
                let laptopTracksPromise = new Promise((resolveLaptop, rejectLaptop) => {
                    let laptopTracks;
                    trackService.getAllTracksForDay(laptopCriteria).then(function (response) {
                        if (response && response.data) {
                            laptopTracks = response.data.features;
                        }
                        resolveLaptop({ laptopTracks });
                    })
                    .catch(function (err) {
                        rejectLaptop(err);
                    });
                });

                // Handle request to fetch PHONE track info for the day here
                let mobileCriteria = Object.assign({}, criteria);
                mobileCriteria.source = "PHONE";
                let mobileTracksPromise = new Promise((resolve, reject) => {
                    let mobileTracks;
                    trackService.getAllTracksForDay(mobileCriteria).then(function (response) {
                        if (response && response.data) {
                            mobileTracks = response.data.features;
                        }
                        resolve({ mobileTracks });
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                });

                // Resolve requests to the API here
                Promise.all([clientEventPromise, laptopTracksPromise, mobileTracksPromise]).then((values) => {
                    let dayTracks = [];
                    // Make sure they aren't null
                    let clientEvents = (!values[0].clientEvents) ? [] : values[0].clientEvents,
                        laptopTracks = (!values[1].laptopTracks) ? [] : values[1].laptopTracks,
                        phoneTracks = (!values[2].mobileTracks) ? [] : values[2].mobileTracks;

                    // Set the client events in the store call: setClientEvents
                    context.commit(MUTATION_NAMES.SET_CLIENT_EVENTS, clientEvents);

                    // Combine the laptop and phone GPS/track into a single array
                    dayTracks.push(...laptopTracks, ...phoneTracks);
                    // Set the day tracks in the store call: setDayTracks
                    context.commit('setDayClusterAndTracks', dayTracks);
                    // Return
                    resolveOuter({ tracks: dayTracks, events: clientEvents });
                })
                .catch((err) => {
                    rejectOuter(err);
                });
            });
        },

        getTrackAggregate(context, criteria) {
            return new Promise((resolve, reject) => {
                let dayTracks;
								console.log('getTrackAggregate criteria:', criteria)
                trackService.getTrackAggregate(criteria).then(function (response) {
                    if (response && response.data) {
                        // dayTracks = response.data;
                        console.log('getTrackAggregate response.data:', response.data)
                    }

                    // context.commit(MUTATION_NAMES.SET_DAY_TRACKS, dayTracks);
                    // resolve({ tracks: dayTracks });
                    resolve(response.data);
                })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        },
        setSelectedPoint(context, point) {
            context.commit(MUTATION_NAMES.SET_SELECTED_POINT, point);
        },
        setSelectedPointId(context, pointId) {
            context.commit(MUTATION_NAMES.SET_SELECTED_POINT_ID, pointId);
        }
    },
    getters: {
        getTracksForTask: (state) => (taskId) => {
            return state.taskTracks[taskId];
        },
        getGpsPointById: (state) => (pointId) => {
            return state.gpsPoints[pointId];
        },
        getClusterById: (state) => (pointId) => {
            return state.clusters[pointId];
        },
        getClustersForTask: (state) => (taskId) => {
            return state.taskClusters[taskId];
        },
        getTaskFeatures: (state) => {
            return state.taskFeatures;
        },
        getTracks: (state) => {
            let features = [];
            for(let key in Object.keys(state.taskTracks)) {
                features = features.concat(state.taskTracks[key]);
            }
            return features;
        }
    },
    mutations: {
        clearAllTracks(state) {
            state.taskTracks = {};
            state.gpsPoints = {};
            state.clusters = {};
            state.dayTracks = {};
            state.clientEvents = {};
        },
        clearTaskTracks(state) {
            state.taskTracks = {};
        },
        setTaskTracks(state, trackInfo) {
            state.taskTracks[trackInfo.id] = trackInfo.tracks;
        },
        clearGpsPoints(state) {
            state.taskTracks = {};
        },
        setGpsPoint(state, pointInfo) {
            state.gpsPoints[pointInfo.id] = pointInfo.point;
        },
        clearClusters(state) {
            state.clusters = {};
        },
        setCluster(state, clusters) {
            state.clusters = clusters;
        },
        clearDayTracks(state) {
            state.dayTracks = {};
        },
        setDayTracks(state, dayTracks) {
            state.dayTracks = dayTracks;
        },
        setDayClusterAndTracks(state, dayTracks) {
            state.dayClusterAndTracks = dayTracks;
        },
        setSelectedPoint(state, point) {
            state.selectedPoint = point;
        },
        setSelectedPointId(state, pointId) {
            state.selectedPointId = pointId;
        },
        setTaskFeatures(state, taskFeatures) {
            state.taskFeatures = taskFeatures;
        },
        setClientEvents(state, clientEvents) {
            state.clientEvents = clientEvents;
        },
        setIsMapLoading(state, isLoading) {
            state.isMapLoading = isLoading;
        }
	},
    state: {
        taskTracks: {},
        gpsPoints: {},
        clusters: {},
        taskClusters: {},
        dayTracks: {},
        dayClusterAndTracks: {},
        selectedPoint: null,
        selectedPointId: null,
        taskFeatures: [],
        clientEvents: {},
        isMapLoading: false
    }
};

export default tracks;
